<div>
  <textarea
    id="{{ id }}"
    class="w-full text-area"
    [(ngModel)]="value"
    maxlength="{{ limit }}"
    disabled="{{ disabled }}"
    placeholder="{{ placeholder }}"
    rows="{{ rows }}"
    aria-label="Ballot note"
  >
  </textarea>
  <div *ngIf="displayCharactersCount" class="footer body-default-regular">
    {{ (value?.length | number) || 0 }} characters (Maximum
    {{ limit | number }} characters)
  </div>
</div>
